<script setup lang="ts">
// Behavioural port of AI SDK Elements' `SourcesContent` (Apache-2.0, Copyright Vercel); anatomy only.

import AppSource from './AppSource.vue'
import type { SourceEntry } from './source-types'

defineProps<{
  sources: SourceEntry[]
  /** Wired by the root: id/aria attributes tying the region to its trigger. */
  contentAttrs?: Record<string, unknown>
}>()

defineEmits<{
  open: [slug: string]
}>()
</script>

<template>
  <ol v-bind="contentAttrs" class="flex list-none flex-col">
    <li v-for="source in sources" :key="source.ref">
      <AppSource :source="source" @open="$emit('open', $event)" />
    </li>
  </ol>
</template>
